import { render, staticRenderFns } from "./my-finish-proccess.vue?vue&type=template&id=6f4b8877&"
import script from "./my-finish-proccess.vue?vue&type=script&lang=js&"
export * from "./my-finish-proccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports